import * as React from 'react'

import * as Style from './style.css'

import sitterBanner from './sitter_line_bnr.png'
import housekeepingBanner from './kaji_line_bnr.png'

export const ContentLineEntry = (): JSX.Element => {
  return (
    <div className={Style.ContentLineEntry}>
      <div className={Style.ContentLineEntryLinkSitter}>
        <a
          href="https://page.line.me/948lhldb?openQrModal=true"
          className={Style.ContentLineA}
        >
          <img
            src={sitterBanner}
            className={Style.ContentLineImg}
            alt="ベビーシッターLINEお友達登録"
          />
        </a>
      </div>
      <div className={Style.ContentLineEntryLinkHousekeeping}>
        <a
          href="https://page.line.me/771wydqq?openQrModal=true"
          className={Style.ContentLineA}
        >
          <img
            src={housekeepingBanner}
            className={Style.ContentLineImg}
            alt="家事代行LINEお友達登録"
          />
        </a>
      </div>
    </div>
  )
}
